import Home from "../assets/styles/styled-components/home";
import backgroundImg from "../assets/images/hero2.svg";
const Hero = () => {
	return (
		<Home>
			<div className="hero-container">
				<h1> WELCOME TO JOB BOARD </h1>
				<p>your one stop job board...</p>
			</div>
			<div className="hero-image">
				<img src={backgroundImg} alt="hero" />
			</div>
		</Home>
	);
};

export default Hero;
